(function () {
    'use strict';

    angular
        .module('app')
        .factory('ActivosService', ActivosService);

    ActivosService.$inject = ['$http'];

    function ActivosService($http) {

        var service = {
            FiltrosActivos: FiltrosActivos,
            Categories: Categories,
            Activofav: Activofav,
            ActivoExport: ActivoExport,
            SolicitudMensaje: SolicitudMensaje,
            getActivo:getActivo,
            Solicitudes:Solicitudes,
            AlternarDescartada:AlternarDescartada,
            checkStreetView:checkStreetView
        };
        
        function checkStreetView(lat, lng,activo_id) {
           return $http.post('/ajax/checkstreetview', {
                lat: lat,
                lng: lng,
                activo_id: activo_id  
            }).then(function(response) {
		if(response.data.success)
		    return response.data.hasStreetview
		else
		    return false
            }).catch(function(error) {
                return false;
            });
        };
        function FiltrosActivos(vm, startDate, endDate, map) {

            var config = { headers: {} }
            // offset:vm.offset, page:vm.page, limit:vm.limit,
            var url = '/ajax/activosbyfilters';
            if(map)
                url = '/ajax/getcentersjson';
            
            return $http.get(url, {
                params: {
                    filtros: JSON.stringify(vm.filtros),
                    endDate: moment(endDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    startDate: moment(startDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    lang_id: lang_id
                }
            }, config)
                .then(function (data) {

                    return data.data;
                }, function (data) {

                    return data;
                });


        };


        function getActivo(referencia_catastral) {

            var config = { headers: {} }
            
            var url = '/ajax/getactivo';
            
            return $http.get(url, {
                params: {
                    referencia_catastral: referencia_catastral,
                    lang_id: lang_id
                }
            }, config)
                .then(function (data) {
                    
                    return data.data;
                }, function (data) {
                    return data;
                });


        };

        function Categories(vm) {
            var config = { headers: {} }

       return $http.get('/ajax/relacionadoactivos', {
                params: { lang_id: lang_id }
            }, config)
                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

        function Activofav(activo_id) {

            var config = {
                headers: {}
            }

            return $http.get('/ajax/activofavorito', {
                params: {
                    activo_id: activo_id,
                }
            }, config)
                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

        function SolicitudMensaje(Message){
	    
            return $http.post('/ajax/solicitudes/'+Message.formulario_id, { "FormularioHistorial" :  Message }, { headers: {} }).then((data) => {

                return data.data;
            });
        }
        
        function Solicitudes(Message){
            return $http.get('/ajax/solicitudes/'+Message.formulario_id, {params:{}}, { headers: {} }).then((data) => {
                return data.data;
            });
        }

        function AlternarDescartada(data){
            return $http.post('/ajax/alternardescarte/'+data.id,{"descartar" : data.descartar},{headers: {}}).then((data) => {
                
                return data.data;
            })

        }


        function ActivoExport(activo_id) {

            return $http.post('/ajax/exportactivo', {

                activo_id: activo_id

            }, { headers: {} }).then(function (data) {
                return data.data;
            }, function (data) {
                console.log("error");
                return data;
            });

        }

        return service;
    }


})();
